import React from 'react';
import { History } from 'history';
import { Grid } from '@mui/material';
import { FormHeader, Icon, Layout } from '../../components';
import UserModel from '../user/user-model';
import MenuPicklistCard from '../menu/menu-picklistcard.component';
import MenugroupPicklistCard from '../menugroup/menugroup-picklistcard.component';
import ApplayoutRoutes from './app-routes.component';
import AppService from '../../services/app.service';

interface IProps { 
  history: History;
  root?: string;
  sidebarRight?: boolean;
  onLoad?: (data: any) => void;
}

interface IState {
  historyState: any;
  isSidebarCollapse: boolean;
  isScroll: boolean;
}

export default class AppViewDashboard extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      historyState: null,
      isSidebarCollapse: false,
      isScroll: false,
    }
  }

  private isMobile: boolean = AppService.isMobile();
  private isRootPath = () => this.props.history.location.pathname === this.props.root;
  private headerCaption = () => (this.state.historyState?.menugroupCaption || 'Hai ' + UserModel.getUserCaption());
  private fixWidth = () => this.state.isSidebarCollapse? 100 : 250;
  private sxOverflow = {overflowY: this.isMobile? 'hidden' : 'auto', '::-webkit-scrollbar': {display: 'none'}}

  private background = () => {
    return AppService.background({svgName: this.isRootPath()? 'waveAnimate' : ''});
  }

  private formHeader() {
    return (
      <FormHeader history={this.props.history} label={this.headerCaption()}/>
    )
  }

  private onLoadAppbar() {
    this.props.onLoad?.({appbar: {width: this.fixWidth(), logoCaption: this.state.isSidebarCollapse? ' ' : ''}});
  }

  private onClickSidebarCollapse = async() => {
    await this.setState({ isSidebarCollapse: !this.state.isSidebarCollapse });
    localStorage.setItem('isSidebarCollapse', this.state.isSidebarCollapse.toString());
    this.onLoadAppbar();
  }

  public componentDidMount = async() => {
    if (this.isMobile) localStorage.removeItem('isSidebarCollapse');
    await this.setState({isSidebarCollapse: localStorage.getItem('isSidebarCollapse') === 'true'});
    this.onLoadAppbar();
  }

  public componentDidUpdate() {
    const historyState = AppService.historyState();
    if (this.state.historyState !== historyState) this.setState({historyState: historyState});
  }

  render() {
    return (
      <Grid bgcolor={this.isMobile? 'background.default' : 'background.paper'} >
        <Layout fixWidth={this.fixWidth()} direction={this.props.sidebarRight? 'row-reverse' : 'row'} spacing={-1} content={[
          {caption: '', disableCard: true, hide: this.isMobile && !this.isRootPath(), child: 
            <Grid p={0.5} display={this.isMobile? '' : 'flex'} width='100%' mt={this.isMobile? 0 : 8}>
              <Grid width='100%' height={this.isMobile? '100%' : '85vh'} sx={this.sxOverflow} p={1}>
              {this.state.historyState?.menugroupId?
              <MenuPicklistCard history={this.props.history} root={this.props.root} caption={this.isMobile? this.headerCaption() : ' '} menugroupId={this.state.historyState.menugroupId} cardCount={this.state.isSidebarCollapse? 1 : 6} cardIconOnly={this.state.isSidebarCollapse} disableBackButton={!this.isMobile}/>
              : <MenugroupPicklistCard history={this.props.history} root={this.props.root} caption={this.isMobile? this.headerCaption() : ' '} cardCount={6} cardIconOnly={this.state.isSidebarCollapse} disableBackButton={!this.isMobile} />
              }
              </Grid>
              {!this.isMobile && <Grid alignContent='center' sx={{cursor: 'pointer'}} onClick={this.onClickSidebarCollapse}><Icon name='drag_indicator' color='primary.main' /></Grid>}
            </Grid>
          },

          {caption: '', disableCard: true, hide: this.isMobile && this.isRootPath(), child: 
            <Grid height={this.isMobile? '100%' : '100vh'} width='100%' sx={this.sxOverflow}>
              <Grid minHeight={this.isMobile? '80vh' : '98vh'} borderLeft={this.isMobile? 0 : 1} borderTop={this.isMobile? 0 : 1} borderColor='white' sx={{ ...this.background(), backgroundColor: 'background.default', borderTopLeftRadius: this.isMobile || !this.props.sidebarRight? 50 : 0, borderBottomLeftRadius: this.isMobile? 50 : 0, borderTopRightRadius: this.isMobile || this.props.sidebarRight? 50 : 0, borderBottomRightRadius: this.isMobile || this.props.sidebarRight? 50 : 0, }} padding={this.isMobile? 0 : 2} marginTop={this.isMobile? 0: 1} >
                  {this.isRootPath()? this.formHeader()
                  : <ApplayoutRoutes history={this.props.history} root={this.props.root}/>
                  }
              </Grid>
            </Grid>
          },
        ]}
        />         
      </Grid>
    );
  }
}